import { Injectable } from '@angular/core';
import { ofType } from '@ngrx/effects';
import { iif, map, Observable, of, tap } from 'rxjs';
import { BusinessSector } from 'src/app/core/models/common/business-sector.model';
import { BusinessSectorDto } from 'src/app/infrastructure/lobby-proxy/DTOs/business-sector.dto';
import { BusinessSectorProxyService } from 'src/app/infrastructure/lobby-proxy/lobby-proxy-business-sector/business-sector-proxy.service';
import { businessSectorDtoToBusinessSector } from 'src/app/shared/mappings/common-model-dto/business-sector-dto.mapping';
import { AutocompleteStrategyBase, SearchSuggestion } from 'src/app/shared/ui-kit/inputs/autocomplete/search-strategy-base';
import { throwIfLobbyErrorCode } from 'src/app/shared/utils/pipes/throwIfLobbyErrorCode.pipe';

@Injectable({
  providedIn: 'root'
})
export class AutocompleteBusinessSectorSuggestionService extends AutocompleteStrategyBase {

  private businessSectorCache: BusinessSector[] | undefined

  constructor(private readonly businessSectorProxyService: BusinessSectorProxyService) {
    super()
  }

  override loadSuggestions$(text: string, maxSuggestions: number | undefined): Observable<SearchSuggestion[]> {
    return iif(() => !!this.businessSectorCache,

      of(this.businessSectorCache!),

      this.businessSectorProxyService.searchBusinessSector$(
        true
      ).pipe(
        throwIfLobbyErrorCode,
        map((dto => dto.data as BusinessSectorDto[])),
        map(sectorDtos => sectorDtos.map(dto => businessSectorDtoToBusinessSector(dto)!)),
        tap(sectors => this.businessSectorCache = sectors)
      )
    )
      .pipe(
        map(sectors => sectors.filter(sector =>
          sector.description.toLowerCase().includes(text.toLowerCase()) ||
          sector.atecoCode.toLowerCase().startsWith(text.toLowerCase()) ||
          text == ''
        )),
        map(sectors => sectors.map(sector => {
          return { id: sector.id.toString(), value: sector.description } as SearchSuggestion
        })
        )
      )
  }
}
